import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { AccordionPropertiesType } from "@website/ui/accordion/accordion.types";
import { MouseEvent, useState } from "react";
export const useAccordionItem = properties => {
  const $ = _c(22);
  const {
    disabled,
    initialExpanded,
    EndIcon,
    EndIconExpanded,
    endText,
    endTextExpanded
  } = properties;
  const [expanded, setExpanded] = useState(initialExpanded ?? false);
  let t0;
  if ($[0] !== disabled) {
    t0 = event => {
      event.preventDefault();
      if (!disabled) {
        setExpanded(_temp);
      }
    };
    $[0] = disabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onDetailsClick = t0;
  let t1;
  if ($[2] !== expanded) {
    t1 = {
      open: expanded
    };
    $[2] = expanded;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== onDetailsClick) {
    t2 = {
      onClick: onDetailsClick
    };
    $[4] = onDetailsClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = expanded ? "collapse" : "expand";
  const t4 = !endText;
  let t5;
  if ($[6] !== EndIcon || $[7] !== EndIconExpanded || $[8] !== endText || $[9] !== endTextExpanded || $[10] !== expanded) {
    t5 = expanded ? EndIconExpanded || (endText ? undefined : <MaterialIcon name="keyboard_arrow_up" variant="outlined" />) : EndIcon || (endTextExpanded ? undefined : <MaterialIcon name="keyboard_arrow_down" variant="outlined" />);
    $[6] = EndIcon;
    $[7] = EndIconExpanded;
    $[8] = endText;
    $[9] = endTextExpanded;
    $[10] = expanded;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== disabled || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = {
      "aria-label": t3,
      disabled,
      color: "secondary" as const,
      variant: "text" as const,
      equalDimension: t4,
      EndIcon: t5
    };
    $[12] = disabled;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const t7 = expanded ? endTextExpanded || endText || "" : endText || "";
  let t8;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t6 || $[20] !== t7) {
    t8 = {
      detailsProperties: t1,
      summeryProperties: t2,
      buttonProperties: t6,
      buttonText: t7
    };
    $[17] = t1;
    $[18] = t2;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(state) {
  return !state;
}